"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAccountsServiceClient = void 0;
const wealtho2_publicapi_client_1 = require("wealtho2-publicapi-client");
const ServiceClientHelper_1 = require("./ServiceClientHelper");
const enums_1 = require("../enums");
const Constants_1 = __importDefault(require("./Constants"));
class ClientAccountsServiceClient {
    constructor(baseUrl, authService, logger = null, apiConfig) {
        const apiClient = new ServiceClientHelper_1.ServiceClientHelper(authService, logger, apiConfig);
        const clientAccountsClient = new wealtho2_publicapi_client_1.ClientAccountsClient(baseUrl, apiClient.axiosInstance);
        apiClient.setAuthToken(clientAccountsClient, authService.getAccessToken());
        this.apiClient = apiClient;
        this.clientAccountsClient = clientAccountsClient;
    }
    getClientAccountsAsync(skip, take, scope, scopeKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.clientAccountsClient, this.clientAccountsClient.getClientAccounts.bind(this.clientAccountsClient), enums_1.PublicApiName.ClientAccounts, skip, take, scope, scopeKeys);
        });
    }
    // this and other getAll* functions can be made generic remove duplicate logic
    getAllClientAccountsAsync(scope, scopeKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            let skip = this.apiClient.defaultSkip;
            let clientAccounts = [];
            let totalRecordsSoFar = 0;
            let totalRecords = 0;
            do {
                const take = this.apiClient.defaultTake;
                const clientAccountList = yield this.getClientAccountsAsync(skip, take, scope, scopeKeys);
                if (!clientAccountList.totalRecords) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutTotalRecords);
                }
                totalRecords = clientAccountList.totalRecords;
                if (!clientAccountList.recordsReturned) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutRecordsReturned);
                }
                totalRecordsSoFar += clientAccountList.recordsReturned;
                skip += take;
                if (clientAccountList.recordsReturned > 0) {
                    clientAccounts.push(...clientAccountList.data);
                }
            } while (totalRecordsSoFar < totalRecords);
            return clientAccounts;
        });
    }
    getClientAccountAsync(key, includeValueOverTime = false, includeAccounts = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.clientAccountsClient, this.clientAccountsClient.getClientAccount.bind(this.clientAccountsClient), enums_1.PublicApiName.ClientAccountByKey, key, includeValueOverTime, includeAccounts);
        });
    }
    getDocumentsAsync(skip, take, key, documentName = null, documentType = null, dateFrom = null, dateTo = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.clientAccountsClient, this.clientAccountsClient.getDocuments.bind(this.clientAccountsClient), enums_1.PublicApiName.ClientAccountDocuments, key, skip, take, documentName, documentType, dateFrom, dateTo);
        });
    }
    // this and other getAll* functions can be made generic remove duplicate logic
    getAllDocumentsAsync(key, documentName = null, documentType = null, dateFrom = null, dateTo = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let skip = this.apiClient.defaultSkip;
            let documents = [];
            let totalRecordsSoFar = 0;
            let totalRecords = 0;
            do {
                const take = this.apiClient.defaultTake;
                const documentSummaryList = yield this.getDocumentsAsync(skip, take, key, documentName, documentType, dateFrom, dateTo);
                if (!documentSummaryList.totalRecords) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutTotalRecords);
                }
                totalRecords = documentSummaryList.totalRecords;
                if (!documentSummaryList.recordsReturned) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutRecordsReturned);
                }
                totalRecordsSoFar += documentSummaryList.recordsReturned;
                skip += take;
                if (documentSummaryList.recordsReturned > 0) {
                    documents.push(...documentSummaryList.data);
                }
            } while (totalRecordsSoFar < totalRecords);
            return documents;
        });
    }
}
exports.ClientAccountsServiceClient = ClientAccountsServiceClient;
